import { pdfStore } from "@/routes/apt/[apt_code]/analysis/_components/bill-kpi/pdf/pdf-store"
import PdfLayout from "./pdf-layout"

const PdfPreview = () => {
  const { info, xLabels, series } = pdfStore()
  return <PdfLayout info={info} xLabels={xLabels} series={series} />
}

export default PdfPreview
